import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { formatPrice } from './menuData';

const SeccionAlmuerzos = ({ photoUrl }) => {
    const [lunch, setLunch] = useState({ price: null, segundos: [] });

    useEffect(() => {
        let active = true;
        api.get('/api/menu/public/almuerzo/', { baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE })
            .then(({ data }) => {
                if (active && Array.isArray(data?.segundos)) {
                    setLunch({ price: data.price, segundos: data.segundos });
                }
            })
            // Si la API falla, el resto de la sección y del menú se siguen mostrando
            .catch((error) => console.warn('No se pudieron cargar los segundos:', error));
        return () => { active = false; };
    }, []);

    const price = parseFloat(lunch.price);

    return (
        <section id="almuerzos" className="mtn-section">
            <div className="mtn-section-inner">
                <div className="mtn-section-list">
                    <h2 className="mtn-section-title">
                        <i className="bi bi-egg-fried" aria-hidden="true"></i>
                        Almuerzos
                    </h2>
                    <div className="mtn-item-row mtn-lunch-days">
                        <span className="mtn-item-name">Sábados y domingos</span>
                        {price > 0 && (
                            <>
                                <span className="mtn-item-dots" aria-hidden="true"></span>
                                <span className="mtn-item-price">{formatPrice(price)}</span>
                            </>
                        )}
                    </div>
                    <p className="mtn-item-description">
                        Disfruta de nuestros almuerzos caseros, preparados con el sabor y tradición de siempre.
                    </p>

                    {lunch.segundos.length > 0 && (
                        <>
                            <h3 className="mtn-lunch-subtitle">Segundos</h3>
                            <ul className="mtn-items">
                                {lunch.segundos.map((segundo) => (
                                    <li key={segundo.name} className="mtn-item">
                                        <div className="mtn-item-row">
                                            <span className="mtn-lunch-option">{segundo.name}</span>
                                            {parseFloat(segundo.extra_price) > 0 && (
                                                <>
                                                    <span className="mtn-item-dots" aria-hidden="true"></span>
                                                    <span className="mtn-item-price">+{formatPrice(parseFloat(segundo.extra_price))}</span>
                                                </>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}

                    <h3 className="mtn-lunch-subtitle">Cada domingo tenemos algo especial</h3>
                    <p className="mtn-item-description">
                        Además de nuestros almuerzos, disfruta de un plato especial diferente cada semana.
                        Pregunta por el especial del domingo.
                    </p>
                </div>
                <div className="mtn-section-photos">
                    <figure className="mtn-polaroid mtn-polaroid--right">
                        <img src={photoUrl} alt="Salón de La Casa del Tío Nel con mesas decoradas" width="640" height="480" loading="lazy" />
                    </figure>
                </div>
            </div>
        </section>
    );
};

export default SeccionAlmuerzos;
